import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=6bad26db&"
import script from "./InfoCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InfoCard.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bad26db')) {
      api.createRecord('6bad26db', component.options)
    } else {
      api.reload('6bad26db', component.options)
    }
    module.hot.accept("./InfoCard.vue?vue&type=template&id=6bad26db&", function () {
      api.rerender('6bad26db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/ethical-commission/index/components/MainContent/components/InfoCard.vue"
export default component.exports